var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Forbidden")]),_c('p',[_vm._v("很抱歉，你没有相关操作权限，请尝试点击此处 "),_c('a',{attrs:{"href":_vm.loginUrl,"target":"_blank"}},[_vm._v("登陆")])])])}
var staticRenderFns = []

export { render, staticRenderFns }